import React from 'react'

export interface IIconSmArrowDown {}

export default function IconSmArrowDown() {
  return (
    <svg
      className="w-2.5 h-2.5"
      viewBox="0 0 29 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="fill-brij-Mud"
        d="M1.18591 6.84L11.5459 17.2C13.1059 18.76 15.6259 18.76 17.1859 17.2L27.5459 6.84C30.0659 4.32 28.2659 0 24.7059 0H3.98591C0.425908 0 -1.33409 4.32 1.18591 6.84Z"
      />
    </svg>
  )
}
